export enum SmartAlertNotificationType {
  MotExpiry = 'mot_expiry'
}
